import {ElementType, FC} from "react";

interface IText {
    as?: ElementType
    text?: string,
    className?: string
}

const Text:FC<IText> = ({as: Tag = 'div', text, className}) => {
    if(!text) return null;

    return <Tag className={className} dangerouslySetInnerHTML={{__html: text}} />;
}

export default Text